module.exports = __webpack_public_path__ + "static/media/product_category_28.0a6ba018.png";